import { createAction, createApiAction } from 'store';
import * as types from './ActionTypes';

export const updatePrevLocation = createAction(types.UPDATE_PREV_LOCATION);
export const updatePrevCrumbs = createAction(types.UPDATE_PREV_CRUMBS);
export const toggleNavbar = createAction(types.TOGGLE_NAVBAR);

export const getIntegrations = createApiAction(types.GET_INTEGRATIONS);
export const getOrganizationTypes = createApiAction(
	types.GET_ORGANISATION_TYPES,
);
